import { Component, OnInit, Input } from '@angular/core';
import {
  ResiduosGestionadosControllerService,
  ResiduosGestionadosDTO,
  ResiduosGestionadosFilterDTO,
  PageDTOResiduosGestionadosDTO,
} from 'api-rest';
import { SpinnerService } from '../../services/spinner.service';
import { SnackbarService } from '../../services/snackbar.service';

@Component({
  selector: 'managers-agreements-detail-authorized-waste',
  templateUrl: './detail-authorized-waste.component.html',
  styleUrls: ['./detail-authorized-waste.component.scss']
})
export class DetailAuthorizedWasteComponent implements OnInit {

  @Input() acuerdoIndirectoInfo!: any;

  pageNumber: number = 1;
  pageSize: number = 25;
  recordsTotal: number = 0;

  itemsPerPageOptions: number[] = [25, 50, 75, 100];
  selectedItemsPerPage: number = 25;

  gridArray: ResiduosGestionadosDTO[] = [];

  headArray: any = [
    {
      Head: 'Nima instalación',
      FieldName: 'gestoresResiduos',
      Attribute: 'nima',
    },
    {
      Head: 'Provincia',
      FieldName: 'gestoresResiduos',
      renderValue: ((item: any) => {
       const domicilioFisica = item?.gestoresResiduos?.domicilios?.find((domicilio: any) => domicilio?.tipoDireccion.descripcion === 'Física');
       return domicilioFisica ? domicilioFisica.provincia.nombre : '';
      })
    },
    {
      Head: 'Autorización',
      FieldName: 'gestoresResiduos',
      Attribute: 'numeroAutorizacion',
    },
    {
      Head: 'Códigos LER Autorizados',
      FieldName: 'codigoLer',
      renderValue: (item: any) =>
        item.operacionGestion
          ? `${item.codigoLer.tipoCodigo} - ${item.codigoLer.descripcion}`
          : ''
    },
    // {
    //   Head: 'Descripción código LER',
    //   FieldName: 'codigoLer',
    //   Attribute: 'descripcion',
    //   Tooltip: true,
    // },
  {
  Head: 'Operaciones de valorización',
  FieldName: 'operacionGestion',
  renderValue: (item: any) =>
    item.operacionGestion
      ? `${item.operacionGestion.codigo} - ${item.operacionGestion.descripcion}`
      : ''
}
    // {
    //   Head: 'Cantidad anual autorizada',
    //   FieldName: 'cantidadAnualAutorizada',
    // },
    // {
    //   Head: 'Fecha desde',
    //   FieldName: 'fechaDesde',
    // },
    // {
    //   Head: 'Fecha hasta',
    //   FieldName: 'fechaHasta',
    // },
    // {
    //   Head: 'Activa',
    //   FieldName: 'autorizacionActiva',
    //   renderValue: (item: any) => (item.autorizacionActiva ? 'SI' : 'NO'),
    // },
  ];

  constructor(
    private residuosGestionadosController: ResiduosGestionadosControllerService,
    private spinnerSrv: SpinnerService,
    private snackBarSrv: SnackbarService
  ) {
  }

  ngOnInit(): void {
    this.buscarResiduosGestionados();
  }

  buscarResiduosGestionados() {

    if(this.acuerdoIndirectoInfo?.gestoresResiduos?.length === 0) {
      this.gridArray = [];
      this.recordsTotal = 0;
      return;
    }

    const filtro: ResiduosGestionadosFilterDTO = {
      gestoresResiduos: {
        //Todos los gestores de un acuerdo indirecto tienen el mismo codigo de documento
        //codigoDocumento: this.acuerdoIndirectoInfo?.gestoresResiduos[0]?.codigoDocumento,
        id: this.acuerdoIndirectoInfo?.gestoresResiduos?.map((gestor: any) => gestor.id)
      }
    };

    const page = this.pageNumber <= 1 ? 0 : this.pageNumber - 1;
    this.spinnerSrv.loadingShow();
    this.residuosGestionadosController
      .findAll2(filtro, { page: page, size: this.pageSize, sort: ['id,desc'] })
      .subscribe({
        next: (data: PageDTOResiduosGestionadosDTO) => {
          this.spinnerSrv.loadingHide();
          this.gridArray = data.datos ?? [];
          this.recordsTotal = data.paginacion?.totalElements ?? 0;
        },
        error: (err) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'Ha ocurrido un error al obtener las autorizaciones de residuos',
            'error'
          );
          console.log(err);
        },
      });
  }

  renderPage(event: number) {
    this.pageNumber = event;
    this.buscarResiduosGestionados();
  }

  onItemsPerPageChange() {
    this.pageSize = this.selectedItemsPerPage;
    this.buscarResiduosGestionados();
  }
  hasMultiplePages(): boolean {
    const total = this.recordsTotal ?? 0;
    const size = this.pageSize ?? 0;
    return size > 0 && total > size;
  }
}
